import React, { useEffect, useState } from 'react'
import { Table, Grid } from '@scuf/common'
import baseServices from '../../../services/base.services'

// eslint-disable-next-line
const TablaGeneralDomo = ({body: body}) => {
    const [state, setState] = useState(null)
    const [headerTableState, setHeaderTableState] = useState([])


    useEffect(() => {
        const getTTeg = async () => {
            try {
                var response = await baseServices.getTostacionModeloDomo(body)
                if (response.data && response.data.length > 0) {
                    setState(response.data)
                    setHeaderTableState(Reflect.ownKeys(response.data[0]))
                }   

            }
            catch (e) {
                console.log(e)
                getTTeg()
            }
        }
        getTTeg()
    }, [body])

    return (
        <>
            {state &&
                <>
                    <Grid.Row>
                        <Grid.Column xsWidth={12} width={12}>
                            <div  className='table-general'>
                            <Table>
                                <Table.Header>
                                    {headerTableState.map(x => <Table.HeaderCell content={x} />)}
                                </Table.Header>
                                <Table.Body>
                                    {
                                        state.map((x, i) =>
                                     
                                        {
                                            return <Table.Row>
                                              
                                                {Object.values(x).map(y=>
                                                    {    return <Table.Cell>
                                                          {y}
                                                        </Table.Cell>
                                                    }
                                                    )}
                                         
                                           
                                            </Table.Row>}
                                        )}
                                </Table.Body>
                            </Table>
                            </div>
                        </Grid.Column>
                        
                    </Grid.Row>

                </>
            }
        </>
    )
}

export default TablaGeneralDomo
